<template>
  <a href="/2012/poster.pdf" target="_blank">
    <img
      src="/2012/poster_sample.jpg"
      alt="VIZBI 2012 conference poster"
      class="poster"
      title="Click here to download the VIZBI 2012 conference poster" />
  </a>
  <p>
    VIZBI 2012, the 3<sup>rd</sup> international meeting on Visualizing Biological Data &mdash; and
    the first in a series of EMBO conferences &mdash; was held 6&ndash;8 March 2012 at
    <a href="http://www.embl.de/">EMBL-Heidelberg</a> in Germany. VIZBI brings together scientists,
    illustrators, and designers actively using or developing computational visualization to study a
    diverse range of biological data.
  </p>
  <p>
    The conference featured
    <router-link to="People">22 invited talks</router-link> that reviewed the state-of-the-art and
    challenges in visualizing data from genomes, transcripts, proteins, cells, organisms, and
    populations. Prior to the meeting (5 March), there were also
    <router-link to="Program">tutorials</router-link> on several visualization tools.
  </p>
</template>

<style scoped>
img.poster {
  float: right;
  margin: 0 0 12px 12px;
  max-width: 240px;
  width: 35%;
  height: auto;
}
</style>
